import { AspectRatio, Image } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useLazyLoad } from '~/hooks/useLazyLoad';

/**
 * @param {{ src?: string, fallbackSrc?: string, ratio?: ResponsiveArray<number>, [index: string]: any}} props
 */
export const LazyImage = ({
  src,
  fallbackSrc,
  ratio = 1,
  imageProps = {},
  ...aspectRatioProps
}) => {
  const {
    imageData,
    onError,
    onLoad,
    ref,
    src: imageSrc,
    styles,
  } = useLazyLoad({
    fallbackSrc,
    src,
  });
  return (
    <AspectRatio ratio={ratio} {...aspectRatioProps}>
      <Image
        fit="cover"
        fontSize={0} // Hide Alt Text on image load on Firefox
        height="100%"
        onError={onError}
        onLoad={onLoad}
        ref={ref}
        src={imageSrc}
        data-src={src}
        width="100%"
        {...styles}
        {...{ ...imageProps, ...imageData }}
      />
    </AspectRatio>
  );
};

LazyImage.propTypes = {
  fallbackSrc: PropTypes.string,
  imageProps: PropTypes.shape({}),
  ratio: PropTypes.number,
  src: PropTypes.string,
};
